import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { ProfileAvatar } from "../../Components/ProfileAvatar/ProfileAvatar";
import { useGetProfileQuery } from "../../../redux/reducers/apiSlice";
import { Link } from "react-router-dom";
import useScreenType from "react-screentype-hook";
import useSignout from "../../hooks/useSignout";



const ProfileMenu = () => {
  const { isMobile, isTablet } = useScreenType();
  const { currentData: currentProfile } = useGetProfileQuery();
  const { signOut } = useSignout()

  return (
    <Menu>
      <MenuButton data-cy="cypress-profile-button-click">
        <ProfileAvatar
          size={isTablet || isMobile ? "sm" : "md"}
          src={currentProfile?.image?.url}
          name={`${currentProfile?.name.firstName} ${currentProfile?.name.lastName}`}
        />
      </MenuButton>

      <MenuList>
        <MenuItem as={Link} to={`/users/${currentProfile?.id}`} data-cy="cypress-view-profile-button-click">
          View my profile
        </MenuItem>
        <MenuItem
          style={{ fontWeight: "bold", color: "red" }}
          onClick={signOut}
          data-cy="cypress-logout-button-click"
        >
          Sign out
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ProfileMenu;